import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { PermissionChecker } from '../../session'
import AddNewButton from './AddNewButton'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SideMenuTemplate from '../../../components/templates/v2/SideMenuTemplate'
import PageHeader from './PageHeader'
import WebhookLoader from './_load/WebhookLoader'
import WebhookTable from './table/WebhookTable'
import ControlBar from './ControlBar'

const WebhookListPage = () => {
  return (
    <SideMenuTemplate bgColor="white">
      <Separator weight={6} flex={1}>
        <PermissionChecker permission="listIntegration">
          <FilterHandler initialState={{}}>
            <PageHeader />
            <ControlBar />
            <WebhookLoader>
              <WebhookTable />
            </WebhookLoader>
            <Separator weight={4} />
          </FilterHandler>
          <AddNewButton />
          <Separator weight={90} />
        </PermissionChecker>
      </Separator>
    </SideMenuTemplate>
  )
}

export default WebhookListPage
